// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__jiLCG","Item":"Hero_Item__1B6o0","Parts":"Hero_Parts__3rukk","Title":"Hero_Title__3ekTg","Description":"Hero_Description__20gjJ"};